import React from 'react';
import ReqTechStepperContainer from '../../containers/reqtechmng/ReqTechStepperContainer';

const ReqTechViewPage = () => {
  return <ReqTechStepperContainer />
};

export default ReqTechViewPage;
